import React from 'react';
import { Security16 } from '@carbon/icons-react';
import { t, tString } from 'components/translation/Translation';
import { Link } from 'react-router';
import styles from './disclaimer.module.scss';

export const Disclaimer = ({ className, contact }) => {
  return (
    <div className={`${styles.disclaimer} ${className}`}>
      <Security16 />
      <p className="body-small">
        {tString('contactSchool:safetyLabel')}
        {contact && (
          <>
            {t('contactSchool:safetyLabelLink')}
            <a href="https://static.schola.com/ScholaTOSFinal.pdf" rel="noreferrer" target="_blank">
              {tString('schoolProfile:unclaimedForm.terms')}
            </a>

            {tString('schoolProfile:unclaimedForm.and')}
            <Link to="/privacy">{tString('schoolProfile:unclaimedForm.privacy')}</Link>
          </>
        )}
      </p>
    </div>
  );
};
